import * as React from "react";
import PropTypes from "prop-types";

import * as styles from "../styles/components/Modal.css";
import closeIcon from "../assets/svg/icon-close.svg";
import ScrollLockDiv from "./ScrollLockDiv";

export default class Modal extends React.PureComponent {
    constructor(props) {
        super(props);
        this.handleDismiss = this.handleDismiss.bind(this);
        this.handleContentClick = this.handleContentClick.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
    }

    componentWillMount() {
        document.addEventListener("keydown", this.handleKeyPress);
    }

    componentWillUnmount() {
        document.removeEventListener("keydown", this.handleKeyPress);
    }

    handleKeyPress(event) {
        switch (event.key) {
            case "Escape":
            case "Enter":
                this.handleDismiss(event);
                break;
            default:
                break;
        }
    }

    handleDismiss(event) {
        if (event) {
            event.stopPropagation();
            event.preventDefault();
        }
        this.props.onDismiss();
    }

    handleContentClick(event) {
        if (event) {
            event.stopPropagation();
            event.preventDefault();
        }
    }

    render() {
        return (
            <ScrollLockDiv
                className={styles.modalBackdrop}
                onClick={this.handleDismiss}
            >
                <div className={styles.modal} onClick={this.handleContentClick}>
                    <img
                        className={styles.dismiss}
                        src={closeIcon}
                        onClick={this.handleDismiss}
                    />
                    {this.props.children}
                </div>
            </ScrollLockDiv>
        );
    }
}

Modal.defaultProps = {};

Modal.propTypes = {
    children: PropTypes.node,
    onDismiss: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/components/Modal.js